export default __webpack_public_path__ + "../staticImages/klimaprojekte-DE-Inverse.png";